export const INITIAL_VALUES = {
  lot: "",
  reservePrice: "",
  name: "",
  stakeholder: "",
};

export const ONLINE_INITIAL_VALUES = {
  lot: "",
  name: "",
  assetFamily: "",
  startPrice: "",
  minStep: "",
  reservePrice: "",
  customClearance: false,
  stakeholder: "",
  brand: "",
  model: "",
  country: {},
  driverSide: "",
  yearOfMake: "",
  mileage: "",
  engine: "",
  transmission: "",
  inspectionReport: "",
  description: "",
  video: "",
  images: [] as Array<GalleryImage | ExtendFile>,
};

export interface GalleryImage {
  id: string;
  isDelete: boolean;
  isDraft: boolean;
  url: string;
}

export type ExtendFile = File & GalleryImage;
